/* FULL OPTIMIZED APP.JS GENERATED FOR shoppingdeals.in */
/* Sidebar loads instantly, all Pages are Lazy Loaded */

import React, {
  createContext,
  useReducer,
  useEffect,
  Suspense
} from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.css";

import ReactGa from "react-ga";

import { initialState, reducer } from "./reducer/UseReducer";
import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { api } from "./components/utils/api";

/* ✅ Sidebar loads immediately */
import Sidebar from "./components/Sidebar/Sidebar";
import { CompareProvider, useCompare } from "./context/CompareContext";
import CompareTray from "./components/CompareTray";
/* ✅ Lazy Loaded Pages */
const Home = React.lazy(() => import("./components/pages/Home"));
const UpadeItemPage = React.lazy(() => import("./components/Admin/pages/UpdateItemPage"));
const Login = React.lazy(() => import("./components/pages/Login"));
const ProductListPage = React.lazy(() => import("./components/pages/SiteMap"));
const SignUp = React.lazy(() => import("./components/pages/Signup"));
const LogOut = React.lazy(() => import("./components/pages/Logout"));
const AddItem = React.lazy(() => import("./components/Admin/AddItem"));
const UpdateItem = React.lazy(() => import("./components/Admin/UpdateItem"));
const SearchTerm = React.lazy(() => import("./components/Admin/SearchTerm"));
const ItemClicked = React.lazy(() => import("./components/Admin/ItemClicked"));
const AdminLog = React.lazy(() => import("./components/Admin/AdminLog"));
const UserActivity = React.lazy(() => import("./components/Admin/UserActivity"));
const Category = React.lazy(() => import("./components/pages/Category"));
const UnderPrice = React.lazy(() => import("./components/pages/UnderPrice"));
const Trending = React.lazy(() => import("./components/pages/Trending"));
const AboutUs = React.lazy(() => import("./components/pages/AboutUs"));
const BugTracker = React.lazy(() => import("./components/Admin/BugTracker"));
const ItemDetalis = React.lazy(() =>
  import("./components/pages/ItemDetails")
);
const ItemBySlug = React.lazy(() =>
  import("./components/pages/ItemBySlug")
);
const BlogDetail = React.lazy(() =>
  import("./components/blogs/BlogDetail")
);
const BlogRedirect = React.lazy(() =>
  import("./components/blogs/BlogRedirect")
);
const BlogBedsheet = React.lazy(() =>
  import("./components/Categories/BedsheetHtml")
);
const MiniAc = React.lazy(() => import("./components/Categories/MiniAc"));
const Laptop = React.lazy(() => import("./components/Categories/Laptop"));
const WomenFashion = React.lazy(() =>
  import("./components/Categories/WomenFashion")
);
const CouponHome = React.lazy(() =>
  import("./components/coupon/CouponHome")
);
const Quiz = React.lazy(() => import("./components/quiz/quiz"));
const QuizAdd = React.lazy(() => import("./components/quiz/quizAdd"));
const QuizUpdate = React.lazy(() => import("./components/quiz/quizUpdate"));
const CouponMakeMyTrip = React.lazy(() =>
  import("./components/coupon/CouponMakeMyTrip")
);
const CouponRedBus = React.lazy(() =>
  import("./components/coupon/CouponRedBus")
);
const CouponAbhiBus = React.lazy(() =>
  import("./components/coupon/CouponAbhiBus")
);
const CouponUpdate = React.lazy(() =>
  import("./components/Admin/CouponUpdate")
);
const ProductPage = React.lazy(() =>
  import("./components/pages/ProductPage")
);
const CouponAdd = React.lazy(() => import("./components/Admin/CouponAdd"));
const Admin = React.lazy(() => import("./components/pages/Admin"));
const CouponPaytm = React.lazy(() =>
  import("./components/coupon/CouponPaytm")
);
const RentVsBuy = React.lazy(() =>
  import("./components/finance/RentVsBuy")
);
const CreditCardCalculator = React.lazy(() =>
  import("./components/finance/CreditCardCalculator")
);
const CarLeaseVsBuy = React.lazy(() =>
  import("./components/finance/CarLeasevsBuy")
);
const EducationCost = React.lazy(() =>
  import("./components/finance/EducationCost")
);
const RetirementPlanner = React.lazy(() =>
  import("./components/finance/RetirementPlanner")
);
const SipVsLumpSum = React.lazy(() =>
  import("./components/finance/SipVsLumpSum")
);
const RealEstateROI = React.lazy(() =>
  import("./components/finance/RealEstateROIBlog")
);
const ForclosourCalculator = React.lazy(() =>
  import("./components/finance/ForclosourCalculator")
);
const NriInvest = React.lazy(() =>
  import("./components/finance/NriInvestment")
);
const EmiCalculator = React.lazy(() =>
  import("./components/finance/EmiCalculator")
);
const MarriageCost = React.lazy(() =>
  import("./components/finance/MarriageCost")
);
const SideHustle = React.lazy(() =>
  import("./components/finance/SideHustle")
);
const FinanceTools = React.lazy(() =>
  import("./components/finance/FinanceTools")
);
const CategoryHome = React.lazy(() =>
  import("./components/Categories/CategoryHome")
);
const S24OneUi7Update = React.lazy(() =>
  import("./components/blogs/S24OneUi7Update")
);
const BlogSmartphoneGuide = React.lazy(() =>
  import("./components/blogs/smartphoneGuide")
);
const UserLogin = React.lazy(() =>
  import("./components/pages/UserLogin")
);
const PhoneAuth = React.lazy(() =>
  import("./components/pages/PhoneAuth")
);
const UserDashboard = React.lazy(() =>
  import("./components/pages/Dashboard")
);
const AdminDashboard2 = React.lazy(() =>
  import("./components/pages/AdminDashboard2")
);
const VoucherDashboard = React.lazy(() =>
  import("./components/pages/VoucherDashboard")
);
const MailDashboard = React.lazy(() =>
  import("./components/Admin/MailDashboard")
);
const SecurityLogDashboard = React.lazy(() =>
  import("./components/pages/SecurityLogDashboard")
);
const MainDashboard = React.lazy(() =>
  import("./components/pages/MainDashboard")
);
const AuthHandler = React.lazy(() =>
  import("./components/pages/AuthHandler")
);
const ContactForm = React.lazy(() =>
  import("./components/pages/ContactForm")
);
const AdminTickets = React.lazy(() =>
  import("./components/pages/AdminTicket")
);
const HomeKitchenCategory = React.lazy(() =>
  import("./components/Categories/HomeAndKitchen")
);
const Beauty = React.lazy(() =>
  import("./components/Categories/Beauty")
);
const Electronics = React.lazy(() =>
  import("./components/Categories/Electronics")
);
const GroceryGourmetCategory = React.lazy(() =>
  import("./components/Categories/Grocery")
);
const ClothingAcessories = React.lazy(() =>
  import("./components/Categories/Clothing")
);
const HealthPersonalCareCategory = React.lazy(() =>
  import("./components/Categories/HealthPersonalCare")
);
const ComputerAccessories = React.lazy(() =>
  import("./components/Categories/ComputerAccessories")
);
const Toys = React.lazy(() =>
  import("./components/Categories/Toys")
);
const Sweets = React.lazy(() =>
  import("./components/Categories/Sweets")
);
const MobileAccessories = React.lazy(() =>
  import("./components/Categories/MobileAccessories")
);
const BestAmazonDealsUnder999 = React.lazy(() =>
  import("./components/blogs/BestAmazonDealUnder999")
);
const BestKitchenGadgetsUnder499 = React.lazy(() =>
  import("./components/blogs/BestKitchenGadgetsUnder499")
);
const BestSmartphonesUnder20000 = React.lazy(() =>
  import("./components/blogs/BestSmartphonesUnder20000")
);
const AmazonShoppingGuideIndia = React.lazy(() =>
  import("./components/blogs/AmazonShoppingGuideIndia")
);
const KitchenAppliancesUnder5000 = React.lazy(() =>
  import("./components/blogs/KitchenAppliancesUnder5000")
);
const SaveMoneyOnlineShopping = React.lazy(() =>
  import("./components/blogs/SaveMoneyOnlineShopping")
);
const TopElectronicsIndianHomes = React.lazy(() =>
  import("./components/blogs/TopElectronicsIndianHomes")
);
const AmazonGreatIndianFestival = React.lazy(() =>
  import("./components/pages/AmazonGreatIndianFestival")
);
const CompareItems = React.lazy(() => import("./components/pages/CompareItems"));
const CompareSelection = React.lazy(() => import("./components/pages/CompareSelectionPage"));
const NotFound = React.lazy(() => import("./components/pages/NotFound"));
const AddFromUrl = React.lazy(() => import("./components/Admin/AddFromUrl"));
/* ✅ Context stays the same */
export const userContext = createContext();

function BodyPaddingManager() {
  const { selected } = useCompare();

  useEffect(() => {
    const trayHeight = window.innerWidth < 550 ? 140 : 90; // MOBILE TRAY IS TALLER
    const root = document.getElementById("root");

    if (root) {
      root.style.paddingBottom =
        selected.length > 0 ? `${trayHeight}px` : "0px";
    }
  }, [selected]);

  return null;
}

function App() {
  const location = useLocation();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      setTimeout(() => {
        ReactGa.initialize("G-0TB1B3EK5X");
        ReactGa.pageview(window.location.pathname + window.location.search);
      }, 800);
    }
  }, [location.pathname]);

  /* ✅ Scroll reset */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

useEffect(() => {
  if (!window.__ALLOW_FIREBASE_IFRAME) return;
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    //to debug login uncomment below log
    // console.log("Auth state changed - User:", user);
    if (user && window.location.pathname === '/login') {
      try {
        const idToken = await user.getIdToken();
        localStorage.setItem("token", idToken);
        await api.post("/users/upsert", { name: user.displayName });
        window.location.replace("/dashboard");
      } catch (error) {
        console.error("Error in auth redirect:", error);
      }
    }
  });
  return () => unsubscribe();
}, []);

  /* ✅ Adsense loads after window load */
  useEffect(() => {
    window.addEventListener(
      "load",
      () => {
        const s = document.createElement("script");
        s.src =
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        s.async = true;
        document.body.appendChild(s);
      },
      { once: true }
    );
  }, []);

 
  const [state, dispatch] = useReducer(reducer, initialState);



  // ExternalRedirect Component
  function ExternalRedirect({ to }) {
    const navigate = useNavigate();

    useEffect(() => {
      window.location.href = to;
    }, [to, navigate]);

    return null;
  }

useEffect(() => {
  // Check if we're on the wrong domain after auth
  if (window.location.hostname.includes('firebaseapp.com') && 
      window.location.pathname.includes('/__/auth/handler')) {
    
    // Redirect to your custom domain with all the auth parameters
    setTimeout(() => {
        const newUrl = `https://shoppingdeals.in/auth-callback${window.location.search}${window.location.hash}`;
        console.log("Redirecting from Firebase domain to:", newUrl);
        window.location.href = newUrl;
    }, 1000);
  }
}, []);

  return (
    <userContext.Provider value={{ state, dispatch }}>
      <Sidebar />
      <Suspense fallback={<div style={{ padding: 40 }}>Loading...</div>}>
      <CompareProvider>
      <BodyPaddingManager />
      <CompareTray />
        <Routes>
          <Route path="/auth-callback" element={<AuthHandler />} />

          <Route exact path="/" element={<Home />}>
            {/* <Home /> */}
          </Route>
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/log-dashboard" element={<SecurityLogDashboard />} />
          <Route path="/admin-dashboard2" element={<AdminDashboard2 />} />
          <Route path="/admin/add-from-url" element={<AddFromUrl />} />
          <Route path="/voucher-dashboard" element={<VoucherDashboard />} />
          <Route path="/main-dashboard" element={<MainDashboard />} />
          <Route path="/contact-us" element={<ContactForm />} />
          <Route path="/contact-us-admin" element={<AdminTickets />} />
          <Route path="/mail" element={<MailDashboard />} />
          <Route path="/bug-tracker" element={<BugTracker />} />
          {/* <SpinTheWheel useExperimentMode={false} apiEndpoint="/api/spin" /> */}
          {/* <ScratchCard
            useExperimentMode={false}
            apiEndpoint="https://your-backend.com/api/get-reward"
          /> */}

          <Route path="/login" element={<UserLogin />} />
          <Route path="/phone-auth" element={<PhoneAuth />} />

          {/* {process.env.NODE_ENV === 'development' && */}
          <Route path="/add-item" element={<AddItem />}>
            {/* <AddItem /> */}
          </Route>
          {/* } */}

          <Route path="/update" element={<UpdateItem />}>
            {/* <UpdateItem /> */}
          </Route>

          <Route path="/category/:id" element={<Category />}>
            {/* <Category /> */}
          </Route>

          <Route path="/csr/loot-deal/:slug" element={<ProductPage />}>
          </Route> 

          <Route path="/loot-deal/:slug" element={<ProductPage />}>
          </Route> 

          {/* <Route path="/csr/loot-deal/:slug" element={<ItemBySlug />}>
          </Route>  */}
          
          <Route path="/product-page/" element={<ProductPage />}>
          </Route> 

          <Route path="/loot-deal2/:description/:id" element={<ItemDetalis />}>
            {/* <ItemDetalis/> */}
          </Route> 

          <Route path="/price/:id" element={<UnderPrice />}>
            {/* <UnderPrice /> */}
          </Route>

          {/* {process.env.NODE_ENV === 'development' && */}
          <Route path="/search-term" element={<SearchTerm />}>
            {/* <SearchTerm /> */}
          </Route>
          {/* } */}

          {/* {process.env.NODE_ENV === 'development' && */}
          <Route path="/item-clicked" element={<ItemClicked />}>
            {/* <ItemClicked /> */}
          </Route>
          {/* } */}

          <Route path="/admin-log" element={<AdminLog />}>
            {/* <AdminLog /> */}
          </Route>
          
          <Route path="/admin/user-activity" element={<UserActivity />}> </Route>
          <Route path="/blogs/iphone-15-case" element={<ExternalRedirect to="https://blog.shoppingdeals.in/posts/iphone-15-pro-cover/" />}>
            {/* <BlogRedirect /> */}
          </Route>

          <Route path="/blogs/samsung-galaxy-s24-one-ui-7-update" element={<S24OneUi7Update />}></Route>
          <Route path="/blog/best-amazon-deals-under-999" element={<BestAmazonDealsUnder999 />}></Route>
          <Route path="/blog/best-kitchen-gadgets-under-499" element={<BestKitchenGadgetsUnder499 />}></Route>
          <Route path="/blog/best-smartphones-under-20000" element={<BestSmartphonesUnder20000 />}></Route>
          <Route path="/blog/amazon-shopping-guide-india" element={<AmazonShoppingGuideIndia />}></Route>
          <Route path="/blog/kitchen-appliances-under-5000" element={<KitchenAppliancesUnder5000 />}></Route>
          <Route path="/blog/save-money-online-shopping-india" element={<SaveMoneyOnlineShopping />}></Route>
          <Route path="/blog/top-electronics-indian-homes" element={<TopElectronicsIndianHomes />}></Route>
          <Route path="/amazon-great-indian-festival" element={<AmazonGreatIndianFestival />}></Route>

          <Route path="/blogs/smartphone-buying-guide" element={<BlogSmartphoneGuide />}></Route>
          <Route path="/categories" element={<CategoryHome />}></Route>
          <Route path="/mini-ac-portable-ac" element={<MiniAc />}></Route>
          <Route path="/compare" element={<CompareItems />}></Route>
          <Route path="/select" element={<CompareSelection />}></Route>

          <Route path="/bedsheet" element={<BlogBedsheet />}>
          </Route>

          <Route path="/laptop" element={<Laptop />}>
          </Route>

          <Route path="/women-fashion-discount" element={<WomenFashion />}>
          </Route>

          <Route path="/category/home-kitchen" element={<HomeKitchenCategory />} />
          <Route path="/category/beauty" element={<Beauty />} />
          <Route path="/category/electronics" element={<Electronics />} />
          <Route path="/category/fashion" element={<ClothingAcessories/>} />
          <Route path="/category/grocery-gourmet-foods" element={<GroceryGourmetCategory />} />
          <Route path="/category/health-personal-care" element={<HealthPersonalCareCategory />} />
          <Route path="/category/computers-accessories" element={<ComputerAccessories />} />
          <Route path="/category/toys-and-games" element={<Toys />} />
          <Route path="/category/sweets-and-snacks" element={<Sweets />} />
          <Route path="/category/mobile-accessories" element={<MobileAccessories />} />

          <Route path="/finance/rent-vs-buy-calculator" element={<RentVsBuy />}>
          </Route>

          <Route path="/finance/retirement-planner" element={<RetirementPlanner />}></Route>
          <Route path="/finance/emi-calculator" element={<EmiCalculator />}></Route>
          <Route path="/finance/car-lease-vs-buy" element={<CarLeaseVsBuy />}></Route>
          <Route path="/finance/education-cost-calculator" element={<EducationCost />}></Route>
          <Route path="/finance/sip-vs-lumpsum-calculator" element={<SipVsLumpSum />}></Route>
          <Route path="/finance/real-estate-roi-calculator" element={<RealEstateROI />}></Route>
          <Route path="/finance/loan-forclosour-calculator" element={<ForclosourCalculator />}></Route>
          <Route path="/finance/credit-card-calculator" element={<CreditCardCalculator />}></Route>
          <Route path="/finance/nri-investment-calculator" element={<NriInvest />}></Route>
          <Route path="/finance/marriage-cost-planner" element={<MarriageCost />}></Route>
          <Route path="/finance/side-hustle-roi" element={<SideHustle />}></Route>
          <Route path="/finance" element={<FinanceTools />}></Route>
          
          {process.env.NODE_ENV === 'development' &&
            <Route path="/blogs:id" element={<BlogDetail />}>
              {/* <BlogDetail /> */}
            </Route>
          }
          {process.env.NODE_ENV === 'development' &&
            <Route path="/coupon" element={<CouponHome />}>
              {/* <CouponHome /> */}
            </Route>
          }
          <Route path="/amazon-quiz" element={<Quiz />}>
          </Route>
          {process.env.NODE_ENV === 'development' &&
            <Route path="/quiz-add" element={<QuizAdd />}>
            </Route>
          }
          {process.env.NODE_ENV === 'development' &&
            <Route path="/quiz-update" element={<QuizUpdate />}>
            </Route>
          }
          {process.env.NODE_ENV === 'development' &&
            <Route path="/coupon-update" element={<CouponUpdate />}>
              {/* <CouponUpdate /> */}
            </Route>
          }
          {process.env.NODE_ENV === 'development' &&
            <Route path="/coupon-add" element={<CouponAdd />}>
              {/* <CouponAdd /> */}
            </Route>
          }
          {/* {process.env.NODE_ENV === 'development' && */}
          <Route path="/redbus-coupon-codes" element={<CouponRedBus />}>
              {/* <CouponRedBus /> */}
            </Route>
            <Route path="/abhibus-coupon-codes" element={<CouponAbhiBus />}>
              {/* <CouponRedBus /> */}
            </Route>
            <Route path="/paytm-bus-flight-promo-codes-2023" element={<CouponPaytm />}>
            </Route>
          {/* } */}
          {/* {process.env.NODE_ENV === 'development' && */}
            <Route path="/unlock-unbeatable-travel-deals-cheap-flights-hotels-makemytrip-coupons" element={ <CouponMakeMyTrip/>}>
              {/* <CouponMakeMyTrip /> */}
            </Route>
          {/* } */}
          

          <Route path="/loot-deals" element={<Trending />}>
            {/* <Trending /> */}
          </Route>

          <Route path="/trending" element={<Trending />}>
            {/* <Trending /> */}
          </Route>

          <Route path="/aboutus" element={<AboutUs />}>
            {/* <AboutUs /> */}
          </Route>

          <Route path="/project/shiva/admin" element={<Admin />}>
            {/* <Admin /> */}
          </Route>

          <Route path="/best-deals-on-amazon-india" element={<Home />}>
            {/* <Home /> */}
          </Route>

          {/* {process.env.NODE_ENV === 'development' && */}
          <Route path="/update-item" element={<UpadeItemPage />}>
          </Route>
          {/* } */}

          <Route path="/loginu" element={<Login />}>
            {/* <Login /> */}
          </Route>

          <Route path="/sitemap" element={<ProductListPage />}>
            {/* <ProductListPage /> */}
          </Route>

          <Route path="/signup" element={<SignUp />}>
            {/* <SignUp /> */}
          </Route>

          <Route path="/logout" element={<LogOut />}>
            {/* <LogOut /> */}
          </Route>

          <Route path="*" element={<NotFound />}>
          </Route>
        </Routes>
      </CompareProvider>
      </Suspense>
    </userContext.Provider>
  );
}

export default App;
